"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Polyphemos = void 0;
const Resources_1 = require("../../Resources");
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
class Polyphemos extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.POLYPHEMOS,
            startingMegaCredits: 50,
            cardType: CardType_1.CardType.CORPORATION,
            cardCost: 5,
            metadata: {
                cardNumber: 'R11',
                description: 'You start with 50 M€. Increase your M€ production 5 steps. Gain 5 titanium.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br;
                    b.megacredits(50).nbsp().production((pb) => pb.megacredits(5)).nbsp().titanium(5).digit;
                    b.corpBox('effect', (ce) => {
                        ce.effect('Buying cards to hand costs 5 M€.', (eb) => {
                            eb.cards(1).asterix().startEffect.megacredits(5);
                        });
                    });
                }),
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 5);
        player.addResource(Resources_1.Resources.TITANIUM, 5);
        return undefined;
    }
}
exports.Polyphemos = Polyphemos;
//# sourceMappingURL=Polyphemos.js.map